// This is GTM events for Accordion block in the CMS

export const gtmEventTypes = {
  EXPAND_ACCORDION: 'CMS-ACCORDION-001',
  COLLAPSE_ACCORDION: 'CMS-ACCORDION-002',
}

export const gtmEvents = {
  [gtmEventTypes.EXPAND_ACCORDION]: ({CMSGroupGTM, accordionName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.EXPAND_ACCORDION,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Expanded "${accordionName.toUpperCase()}"`,
  }),
  [gtmEventTypes.COLLAPSE_ACCORDION]: ({CMSGroupGTM, accordionName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.COLLAPSE_ACCORDION,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Collapsed "${accordionName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/accordion-duck.js